/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Teachingsubjectinterest_Subject_Greek14Inputs */

const en__field__enum_teachingsubjectinterest_subject_greek14 = /** @type {(inputs: _Field__Enum_Teachingsubjectinterest_Subject_Greek14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Greek`)
};

const de__field__enum_teachingsubjectinterest_subject_greek14 = /** @type {(inputs: _Field__Enum_Teachingsubjectinterest_Subject_Greek14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Griechisch`)
};

/**
* | output |
* | --- |
* | "Greek" |
*
* @param {_Field__Enum_Teachingsubjectinterest_Subject_Greek14Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_teachingsubjectinterest_subject_greek14 = /** @type {((inputs?: _Field__Enum_Teachingsubjectinterest_Subject_Greek14Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Teachingsubjectinterest_Subject_Greek14Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_teachingsubjectinterest_subject_greek14(inputs)
	return de__field__enum_teachingsubjectinterest_subject_greek14(inputs)
});
export { _field__enum_teachingsubjectinterest_subject_greek14 as "_field__enum_teachingSubjectInterest_SUBJECT_GREEK" }